/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    string,
} from 'prop-types';

const SortByIcon = ({
    fillColor,
}) => (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.27246 0.641602C4.67293 0.641726 4.99795 0.966717 4.99805 1.36719V13.2402L7.20605 11.0322V11.0312C7.4891 10.7485 7.94933 10.7494 8.23242 11.0322C8.51511 11.3153 8.51497 11.7736 8.23242 12.0566L4.78516 15.5039C4.50207 15.7868 4.04188 15.7868 3.75879 15.5039L0.311523 12.0566C0.0298044 11.7738 0.0296589 11.3151 0.311523 11.0322C0.59453 10.7494 1.05482 10.7488 1.33789 11.0312V11.0322L3.54688 13.2402V1.36719C3.54697 0.96664 3.87189 0.641602 4.27246 0.641602ZM12.0928 0.3125C12.3758 0.029725 12.8351 0.0297313 13.1182 0.3125L16.5654 3.75977C16.848 4.04278 16.8482 4.50209 16.5654 4.78516C16.2824 5.06758 15.823 5.06743 15.54 4.78516L13.3311 2.5752V14.4492C13.3311 14.8498 13.0061 15.1748 12.6055 15.1748C12.2049 15.1748 11.8799 14.8498 11.8799 14.4492V2.5752L9.6709 4.78516C9.38792 5.06737 8.9285 5.06764 8.64551 4.78516C8.36314 4.50218 8.36344 4.0427 8.64551 3.75977L12.0928 0.3125Z" fill={fillColor} stroke={fillColor} strokeWidth="0.2" />
    </svg>
);

SortByIcon.propTypes = {
    fillColor: string,
};

SortByIcon.defaultProps = {
    fillColor: '#2F2F2F',
};

export default SortByIcon;
